import { render, staticRenderFns } from "./OneColumnSidebarLeft.vue?vue&type=template&id=c53c17d2&scoped=true&"
import script from "./OneColumnSidebarLeft.vue?vue&type=script&lang=js&"
export * from "./OneColumnSidebarLeft.vue?vue&type=script&lang=js&"
import style0 from "./OneColumnSidebarLeft.vue?vue&type=style&index=0&id=c53c17d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53c17d2",
  null
  
)

export default component.exports